import React from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";

export const AboutMeComponent = () => {
    return (
        <div style={{
            paddingTop: "4%",
            paddingLeft: '4%',
            paddingRight: "4%",
            display: "flex",
            flexDirection: "column",
            alignContent: "center",
            flexWrap: "wrap",
        }}>
            <div>
                <Accordion
                    defaultExpanded={true}
                    style={{backgroundColor: "#FFFFFF", borderRadius: 30 }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMore />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <h4 style={{ textAlign: "center" }}><b>$ <span style={{
                            color: "#007BFF"
                        }}>whois</span> Aniket</b></h4>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div style={{
                            paddingLeft: "3%", paddingRight: "3%", paddingBottom: 20,
                        }}>
                            I'm a junior at <span style={{ color: "#007BFF" }}>Purdue</span> studying CS.<br /><br />
                            I have industry experience in <span style={{ color: "#007BFF" }}>software engineering</span>, primarily in
                            <span style={{ color: "#007BFF" }}> full stack development</span> and
                            <span style={{ color: "#007BFF" }}> competitive programming</span>.<br /><br />

                            I spend my spare time developing applications or working on cool projects related to my passions, all documented here and on GitHub.
                        </div>
                    </AccordionDetails>
                </Accordion>
                <hr />
            </div>
            <div>
                <Accordion
                    defaultExpanded={true}
                    style={{backgroundColor: "#FFFFFF", borderRadius: 30, marginBottom: "5%" }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMore />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                        style={{ marginLeft: "auto", marginRight: "auto" }}
                    >
                        <h4><b>$ <span style={{
                            color: "#007BFF"
                        }}> print</span> Stack</b></h4>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div style={{
                            paddingLeft: "3%", paddingRight: "3%", paddingBottom: 10,
                        }}>
                            <h5><b>bold</b> = main</h5>
                            <br />
                            <p style={{ lineHeight: 0.75, color: "#007BFF", fontSize: "13" }}>Languages</p>
                            <h6><b>Java</b>, <b>Python</b>, <b>C</b>, <b>SQL</b>, R, HTML/CSS</h6>

                            <p style={{ lineHeight: 0.75, paddingTop: 20, color: "#007BFF", fontSize: "13" }}>Frameworks/Libraries</p>
                            <h6><b>ReactJS</b>, <b>React Native</b>, <b>Spring Boot</b>, Hadoop, Spark MapReduce</h6>

                            <p style={{ lineHeight: 0.75, paddingTop: 20, color: "#007BFF", fontSize: "13" }}>Database</p>
                            <h6><b>MySQL</b>, PostgreSQL</h6>

                            <p style={{ lineHeight: 0.75, paddingTop: 20, color: "#007BFF", fontSize: "13" }}>Cloud</p>
                            <h6><b>AWS</b>, <b>Heroku</b>, Google Cloud</h6>

                            <p style={{ lineHeight: 0.75, paddingTop: 20, color: "#007BFF", fontSize: "13" }}>Additional Tools</p>
                            <h6><b>Git</b>, UNIX, <b>Bash</b>, Maven</h6>
                        </div>
                    </AccordionDetails>
                </Accordion>
            </div>
        </div>
    );
}
